import { Route, Routes, Navigate } from "react-router-dom";
import Callback from "./pages/Callback";
import Chat from "./pages/Chat";
import Estimate from "./pages/Estimate";
import NotFound from "./pages/NotFound";
import Preview from "./pages/Preview";
import Start from "./pages/Start";
import Wait from "./pages/Wait";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Start />} />
      <Route path="/wait/" element={<Wait />} />
      <Route path="/estimate" element={<Estimate />} />
      <Route path="/preview" element={<Preview />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" />} />
    </Routes>
  );
}
